module.exports = __webpack_public_path__ + "static/img/ser-c-2.d95a609.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/setmeal/ser-c-2.png
// module id = 7014
// module chunks = 1